import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { LuX, LuBell } from "react-icons/lu";
import { onMessageListener } from "../constants/firebase";
import { notificationRoute } from "../utils/notificationRoutes";
import { getChatId, truncateWords } from "../utils/utils";
import { safeUrl } from "../utils/appData";
export default function NotificationToast() {
  const [notification, setNotification] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const timer = useRef();
  useEffect(() => {
    const unsubscribe = onMessageListener((payload) => {
      const { title, body } = payload.notification || {};
      if (!title && !body) return;
      const data = payload.data || {};
      const [, surface, id] = location.pathname.split("/");
      if (
        data.type === "private" &&
        surface === "chat" &&
        (data.senderId === id ||
          (data.receiverId && getChatId(id, data.receiverId) === data.chatId))
      )
        return;
      if (data.groupId && surface === "group-chat" && id === data.groupId)
        return;
      if (
        data.communityId &&
        surface === "community" &&
        id === data.communityId
      )
        return;
      clearTimeout(timer.current);
      setNotification({ title, body, data, type: data.type });
      timer.current = setTimeout(() => setNotification(null), 4000);
    });
    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
      clearTimeout(timer.current);
    };
  }, [location.pathname]);
  return (
    <AnimatePresence>
      {notification && (
        <motion.div
          initial={{ x: 300, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 300, opacity: 0 }}
          className="fixed right-4 top-4 z-[12000] flex w-[calc(100%_-_32px)] max-w-sm items-start gap-3 rounded-2xl border border-slate-200 bg-white p-4 text-slate-900 shadow-lg dark:border-[#363e46] dark:bg-[#23272c] dark:text-white"
        >
          {safeUrl(notification.data.senderProfilePic) ? (
            <img
              src={safeUrl(notification.data.senderProfilePic)}
              alt=""
              className="h-10 w-10 shrink-0 rounded-full object-cover"
            />
          ) : (
            <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-[#edf3f5] text-[#327691] dark:bg-[#22333a] dark:text-[#5FAFCB]">
              <LuBell size={20} />
            </span>
          )}
          <button
            className="min-w-0 flex-1 text-left"
            onClick={() => {
              navigate(notificationRoute(notification) || "/notifications");
              setNotification(null);
            }}
          >
            <strong className="block text-sm">
              {notification.title || notification.data.senderName || "Zylen"}
            </strong>
            <p className="mt-1 break-words text-xs leading-5 text-slate-500 dark:text-slate-300">
              {truncateWords(notification.body || "", 18)}
            </p>
          </button>
          <button
            onClick={() => setNotification(null)}
            aria-label="Dismiss notification"
            className="shrink-0 p-1 text-slate-400"
          >
            <LuX size={18} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
